module.exports = __webpack_public_path__ + "icon-purse-active.png?90565324250bf6defda6b96e38396c0e";